<script>

export default {
  components: {},
  props: {
    module: Object,
  },
  data: () => ({}),
  computed: {
    disabled() {
      return !this.module.permission.hasAny(1, 4, 8, 9, 46, 52, 113, 124, 166, 167);
    },
  },
};
</script>
<template>
  <v-btn
    icon
    :disabled="disabled"
    title="Администрирование"
    href="/tourclient/admin/admin/"
  >
    <v-icon
      v-text="'mdi-cog'"
    ></v-icon>
  </v-btn>
</template>
<style lang="scss">
</style>
